import React, { useEffect, useReducer } from "react";
import GastosContext from "./gastosContext";
import AlertasContext from "../Alertas/AlertasContext";
import GastosReducer from "./gastosReducer";
import clienteAxios from "../../Services/clienteAxios";
import {
  AGREGAR_GASTO,
  OBTENER_GASTOS,
  ELIMINAR_GASTO,
  GASTO_ACTUAL,
  ACTUALIZAR_GASTO,
} from "../../types";
import { useContext } from "react";

const GastosState = ({ children }) => {
  const { mostrarAlerta } = useContext(AlertasContext);
  const initialState = {
    gastos: [],
    gastoSeleccionado: null,
  };

  const [state, dispatch] = useReducer(GastosReducer, initialState);

  const agregarGasto = async (gasto) => {
    try {
      console.log(gasto);
      const respuesta = await clienteAxios.post("api/gastos/", gasto);
      console.log(respuesta);

      dispatch({ type: AGREGAR_GASTO, payload: respuesta.data.nuevoGasto });
    } catch (error) {
      console.log(error);
    }
  };

  const traerGastos = async () => {
    try {
      const response = await clienteAxios("api/gastos/all");
      console.log(response);

      dispatch({ type: OBTENER_GASTOS, payload: response.data.gastos });
    } catch (error) {
      console.log(error);
      mostrarAlerta(error.response.data.msg);
    }
  };

  const eliminarGasto = async (id) => {
    try {
      const response = await clienteAxios.delete(`api/gastos/${id}`);
      console.log(response);
      dispatch({ type: ELIMINAR_GASTO, payload: id });
    } catch (error) {
      console.log(error);
      mostrarAlerta(error.response.data.msg);
    }
  };

  const seleccionarGasto = (gasto) => {
    dispatch({ type: GASTO_ACTUAL, payload: gasto });
  };

  const actualizarGasto = async (gasto) => {
    try {
      const response = await clienteAxios.put(
        `/api/gastos/${gasto._id}`,
        gasto
      );
      console.log(response);

      dispatch({ type: ACTUALIZAR_GASTO, payload: response.data.gasto });
    } catch (error) {
      console.log(error, "Al editar gasto");
    }
  };

  useEffect(() => {
    traerGastos();
  }, []);

  return (
    <GastosContext.Provider
      value={{
        gastos: state.gastos,
        agregarGasto,
        eliminarGasto,
        actualizarGasto,
        seleccionarGasto,
        gastoSeleccionado: state.gastoSeleccionado,
      }}
    >
      {children}
    </GastosContext.Provider>
  );
};

export default GastosState;
